import GenericFormAddressField from './GenericFormAddressField';
import GenericFormCheckboxField from './GenericFormCheckboxField';
import GenericFormCheckboxGroup from './GenericFormCheckboxGroup';
import GenericFormCheckboxWithValueField from './GenericFormCheckboxWithValueField';
import GenericFormDateField from './GenericFormDateField';
import GenericFormEmailInputField from './GenericFormEmailInputField';
import GenericFormInputField from './GenericFormInputField';
import GenericFormInputSelect from './GenericFormInputSelect';
import GenericFormNameField from './GenericFormNameField';
import GenericFormNumberInputField from './GenericFormNumberInputField';
import GenericFormParagraph from './GenericFormParagraph';
import GenericFormPhoneNumberInputField from './GenericFormPhoneNumberInputField';
import GenericFormRadioGroup from './GenericFormRadioGroup';
import GenericFormSalutationField from './GenericFormSalutationField';
import GenericFormTextAreaInputField from './GenericFormTextAreaInputField';
import type { FormFieldComponent } from './types';

/**
 * The `GenericForm*` blocks this lane renders, keyed by `_type`.
 *
 * These 15 are the ones that appear in migrated content; the bundle declares 21. The other 6
 * (`…BeAddressField`, `…Divider`, `…HiddenConfigurationValueField`, `…InputHiddenField`,
 * `…KVKFinderField`, `…UsageField`) are unused today and render a `[missing component]` marker if
 * content ever introduces one — which is the signal to add them, rather than carrying 6 speculative
 * components. `…CheckboxGroup` and `…CheckboxWithValueField` joined the list once coverage showed
 * them on live pages (11 and 2 pages respectively).
 *
 * `GenericForm` reads `formSchema` off these to assemble the form's validation, so the map is both
 * the render registry and the validation source.
 */
export const formFieldComponents: Record<string, FormFieldComponent> = {
  GenericFormAddressField,
  GenericFormCheckboxField,
  GenericFormCheckboxGroup,
  GenericFormCheckboxWithValueField,
  GenericFormDateField,
  GenericFormEmailInputField,
  GenericFormInputField,
  GenericFormInputSelect,
  GenericFormNameField,
  GenericFormNumberInputField,
  GenericFormParagraph,
  GenericFormPhoneNumberInputField,
  GenericFormRadioGroup,
  GenericFormSalutationField,
  GenericFormTextAreaInputField,
};
